import React from 'react';
import { Accordion } from '../../../components';
import { formatControlValue } from '../../../helpers/Functions';

import { SnippetConfiguration, SnippetDataDictionary } from '../../../services/dataModels';
import { DataRow } from './DataRow';

interface MonitoringSnippetProps {
  path: string;
  configuration: SnippetConfiguration;
  data: SnippetDataDictionary[];
}

const MonitoringSnippet = ({ path, configuration, data }: MonitoringSnippetProps) => {
  const titleControlType = configuration.columns.find(
    (c) => c.name === configuration.rowTitleKey,
  )?.controlType;
  return (
    <>
      {data.map((r, i) => (
        <Accordion
          key={i}
          title={formatControlValue(titleControlType, r[configuration.rowTitleKey] as string)}
          size={configuration.columns.length}>
          <DataRow
            path={`${path}.rowData[${i}]`}
            configuration={configuration.columns}
            data={r}
            disabled={Object.keys(r)}
          />
        </Accordion>
      ))}
    </>
  );
};

export default MonitoringSnippet;
